import { thumbnailSizeMap } from "../shared/Data/consts";
import { fetchPost, appUrl } from "./networkRequests";
import { isBeta } from "./network";

const DBX_ROOT = 'dropbox'
const prot = process.env.REACT_APP_PROTOCOL

const basicRequest = async (args, endPoint, userToken)=>{
  const root_url = await appUrl()
  let body = new FormData()
  for (let key of Object.keys(args)) body.append(key, args[key])
  const full_url = `${prot}:${root_url}/${DBX_ROOT}/${endPoint}`
  let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  return res
}

const filesGetThumbnailBatch = async (arr, resultMapper, userToken)=>{
  const root_url = await appUrl()
  const MAX_REQUEST = 25
  let entries = arr.slice(0)
  let results = []
  if (!resultMapper) resultMapper = (res) => {
    console.log('filesGetThumbnailsBatch | got batch:', res)
    return res
  }
  while (entries.length) {
    let bin = entries.splice(0, MAX_REQUEST).map(itm=>{
      let path = itm.path? itm.path : itm
      let size = itm.thumbnailSize? thumbnailSizeMap[itm.thumbnailSize ] : 'w480h320'
      const tag = '.tag'
      return {path:path, size:{[tag]: size}}
    })
    console.log('getting these items', bin)
    let body = new FormData()
    body.append('entries', JSON.stringify(bin))
    const full_url = `${prot}:${root_url}/${DBX_ROOT}/filesGetThumbnailBatch`
    console.log('about to request thumbnails', full_url, body)
    let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
    
    console.log('got these items', res)
    if (resultMapper) results = [...results, ...resultMapper(res)]
    else results = [...results, ...res]
  }

  return results

}

const getDropboxFile = async (path, userToken)=>{
  // const root_url = await appUrl()
  // let body = new FormData()
  // body.append('path', path)
  // const full_url = `${prot}:${root_url}/${DBX_ROOT}/getDropboxFile`
  // console.log("getting dropbox file", full_url, path)
  // let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  // return res
  return await basicRequest({path}, 'getDropboxFile', userToken)
}

const downloadDropboxFileToLocation = async (path, localPath, userToken)=>{
  
  let dbxFile = await getDropboxFile(path, userToken)
  console.log('got res from getDropboxFile', dbxFile)
  // let buff = await blobToBuffer(dbxFile.fileBlob)
  let buff = dbxFile.fileBinary.data
  let url = URL.createObjectURL(buff)
  const a = document.createElement('a')
  a.href = url
  a.download = 'report_image.jpg'
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
  return
  // return writeFile(localPath, buff)
}

const uploadDropboxFileOverwrite = async (imageBlob, path, userToken)=>{
  const root_url = await appUrl()
  let body = new FormData()
  body.append('image', imageBlob, {
    contentType: 'image/jpeg',
  })
  body.append('path', path)
  const full_url = `${prot}:${root_url}/${DBX_ROOT}/uploadDropboxFileOverwrite`
  let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  return res
}

const uploadDropboxFile = async (imageBlob, path, userToken)=>{
  const root_url = await appUrl()
  let body = new FormData()
  body.append('image', imageBlob, {
    contentType: 'image/jpeg',
  })
  body.append('path', path)
  const full_url = `${prot}:${root_url}/${DBX_ROOT}/uploadDropboxFile`
  let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  return res
}

const checkDropboxPath = async (path, userToken)=>{
  // const root_url = await appUrl()
  // let body = new FormData()
  // body.append('path', path)
  // const full_url = `${prot}:${root_url}/${DBX_ROOT}/checkDropboxPath`
  // let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  // return res
  return basicRequest({path}, 'checkDropboxPath', userToken)
}

const deleteDropboxFile = async (path, userToken)=>{
  // const root_url = await appUrl()
  // let body = new FormData()
  // body.append('path', path)
  // const full_url = `${prot}:${root_url}/${DBX_ROOT}/deleteDropboxFile`
  // let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  // return res
  return basicRequest({path}, 'deleteDropboxFile', userToken)
}

const fileCopy = async (from_path, to_path, userToken)=>{
  // const root_url = await appUrl()
  // let body = new FormData()
  // body.append('from_path', from_path)
  // body.append('to_path', to_path)
  // const full_url = `${prot}:${root_url}/${DBX_ROOT}/fileCopy`
  // let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  // return res
  return basicRequest( {from_path, to_path}, 'fileCopy', userToken)
}

const fullCopyBatch = async (entries, userToken)=>{
  // const root_url = await appUrl()
  // let body = new FormData()
  // body.append('from_path', from_path)
  // body.append('to_path', to_path)
  // const full_url = `${prot}:${root_url}/${DBX_ROOT}/fileCopy`
  // let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  // return res
  return basicRequest( {entries: JSON.stringify(entries)}, 'fullCopyBatch', userToken)
}

const createDropboxFolder = async (path, userToken)=>{
  // const root_url = await appUrl()
  // let body = new FormData()
  // body.append('path', path)
  // const full_url = `${prot}:${root_url}/${DBX_ROOT}/createDropboxFolder`
  // let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  // return res
  return basicRequest({path}, 'createDropboxFolder', userToken)
}

const getDropboxDirListing = async (path, recursive, userToken)=>{
  return basicRequest({path, recursive}, 'getDropboxDirListing', userToken)
}

const getDropboxDirListingContinue = async (cursor, userToken)=>{
  return basicRequest({cursor}, 'getDropboxDirListingContinue', userToken)
}

const getFullDropboxDirListing = async (path, recursive)=>{
  if (typeof recursive !== 'boolean') recursive = false
  console.log('getting listing', path, recursive)

  let resArr = []
  let listRes
  try {
    listRes = await getDropboxDirListing(path, recursive)

  } catch (e) {
    console.warn("Issue locating path possibly", e, path)

  }

  if (listRes) {
    resArr = [...resArr, ...listRes.entries.map(itm => (itm.path_display))]
    let more = listRes.has_more
    let cursor = listRes.cursor
    while (more) {
      const continuedListing = await getDropboxDirListingContinue(cursor)
      resArr = [...resArr, ...continuedListing.entries.map(itm => (itm.path_display))]
      cursor = continuedListing.cursor
      more = continuedListing.has_more
    }

    return resArr
  }
  return false
}

export {
  filesGetThumbnailBatch, 
  downloadDropboxFileToLocation,
  uploadDropboxFileOverwrite,
  checkDropboxPath,
  deleteDropboxFile,
  fileCopy,
  createDropboxFolder,
  getFullDropboxDirListing,
  uploadDropboxFile,
  getDropboxFile,
  fullCopyBatch
}
